import React from 'react'
import { Map } from 'immutable'
import { useDispatch, useSelector } from 'react-redux'
import { b64DecodeUnicode, b64EncodeUnicode } from '../../lib/jsonUtils'
import { projectSyncParams } from '../../store/project/actions'
import { ftGetLocalStorage, ftRemoveLocalStorage, ftSetLocalStorage } from '../../lib/common'
import { isSame } from '../WidgetBuilder/UI/isSame'

export const ProjectParameterSync = () => {
  const dispatch = useDispatch()
  const projectID = useSelector((state) => state.getIn(['project', '_id']))
  const params = useSelector((state) => state.get('params', Map()), isSame)
  const onLoadComplete = React.useRef(true)

  const SYNC_MODE = window.location.href.indexOf('_ftPageMode=modal') !== -1 ? 'modal' : 'page'
  const PageID = window.__FT_STID__

  React.useEffect(() => {
    const PageID = window.__FT_STID__
    if (PageID) {
      let initialParams = ftGetLocalStorage(`${projectID}:${PageID}:params`)
      if (initialParams) {
        try {
          if (SYNC_MODE === 'modal' && initialParams) {
            let data = JSON.parse(b64DecodeUnicode(initialParams))
            dispatch(projectSyncParams(data?.params || {}))
          }
        } catch (error) {}
      }
      onLoadComplete.current = true
    }

    const onStorageChange = (event) => {
      const { key, newValue } = event
      if (key === `${projectID}:${PageID}:params` && onLoadComplete.current) {
        if (newValue) {
          try {
            let newParams = JSON.parse(b64DecodeUnicode(newValue))
            dispatch(projectSyncParams(newParams?.params || {}))
          } catch (error) {}
        }
      }
    }

    const onPageUnload = (event) => {
      if (SYNC_MODE === 'page') {
        ftRemoveLocalStorage(`${projectID}:${PageID}:params`)
      }
    }

    window.addEventListener('storage', onStorageChange)
    window.addEventListener('unload', onPageUnload)

    return () => {
      window.removeEventListener('storage', onStorageChange)
      window.removeEventListener('unload', onPageUnload)
    }
  }, [PageID])

  React.useEffect(() => {
    if (PageID && onLoadComplete.current) {
      let prefParams = ftGetLocalStorage(`${projectID}:${PageID}:params`)
      let prefParamsData = null
      try {
        prefParamsData = _.get(JSON.parse(b64DecodeUnicode(prefParams)), 'params', {})
      } catch (error) {}
      let isSame = true
      let paramsJS = params.toJS()
      _.each(paramsJS, (value, key) => {
        if (key == 'ftSessLeftTime') {
          delete paramsJS['ftSessLeftTime']
        } else if (_.get(prefParamsData, [key]) !== value) {
          isSame = false
        }
      })
      if (!isSame) {
        const state = {
          mode: SYNC_MODE,
          params: paramsJS,
        }
        ftSetLocalStorage(`${projectID}:${PageID}:params`, b64EncodeUnicode(JSON.stringify(state)))
      }
    }
  }, [params, PageID])

  return null
}
